module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media"
  }, [_c('media-player', {
    attrs: {
      "issue": _vm.issue,
      "share": false,
      "header": false
    }
  })], 1), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.issue.authors
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.issue.description))]), _vm._v(" "), _c('div', {
    staticClass: "doi"
  }, [_vm._v("DOI: "), _c('span', [_vm._v(_vm._s(_vm.issue.ids ? _vm.issue.ids.doi : ''))]), _c('br'), _vm._v("\n    Issue: "), _c('span', [_vm._v("Volume " + _vm._s(_vm.issue.volume) + " Number" + _vm._s(_vm.issue.issue.issue))]), _vm._v("\n    pp " + _vm._s(_vm.issue.page_start) + "-" + _vm._s(_vm.issue.page_end))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trimTextToLength(_vm.issue.title, 40)))]), _vm._v(" "), (_vm.showKeywords) ? _c('div', {
    staticClass: "keywords"
  }, [_vm._v("Keywords: "), _c('span', [_vm._v(_vm._s(_vm.issue.keywords.join(', ')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article-quick-links"
  }, [_c('article-quick-links', {
    attrs: {
      "article": _vm.issue
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72272b19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CondensedVideoComponent.vue
// module id = 1451
// module chunks = 1